<template>
  <modal
    v-if="show"
    width="920px"
    height="800px"
    class="details-dialog"
    :title="t('Rules')"
    @close="checkClose"
    :read-article-url="`https://docs.bemob.com/${$i18n.locale}/campaign-creation-destination-settings`"
  >
    <rule-settings
      class="rule-wrapper"
      :target="{}"
      :rule="active_rule"
      :active_name="active_name"
      v-model:relation="relation"
    ></rule-settings>

    <template #footer>
      <section class="justify-end xs12" style="display: flex">
        <ui-button
          :text="t('Cancel')"
          icon="fas fa-times"
          @click="checkClose"
        ></ui-button>

        <ui-button
          data-action="save"
          :text="t('Save')"
          icon="fas fa-check"
          button-style="accent"
          :loading="loading"
          @click="save"
        ></ui-button>
      </section>
    </template>
  </modal>
</template>

<script setup lang="ts">
import RuleSettings from './rule-settings.vue';
import {
  useCampaignRuleDialog,
  type CampaignRuleDialogData,
} from './useCampaignRuleDialog';

const props = withDefaults(
  defineProps<{
    data?: CampaignRuleDialogData;
  }>(),
  {
    data: () => ({}),
  },
);

const emit = defineEmits<{
  close: [];
}>();

const {
  t,
  show,
  loading,
  active_name,
  active_rule,
  relation,
  checkClose,
  save,
} = useCampaignRuleDialog(() => props.data, () => emit('close'));
</script>

<style lang="scss" scoped>
.rule-wrapper {
  height: 100%;
  overflow: auto;
}
</style>
